var _rect, _rect2, _g, _path, _g2, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignupBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2216_76033)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "url(#paint0_linear_2216_76033)",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "#002D62"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2216_76033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M920.247 427.639C920.247 427.639 909.23 309.397 1034.25 314.139C1153.99 318.681 1391.25 427.639 1391.25 427.639V993.639C1391.25 993.639 1237.63 883.794 1096.25 766.139C926.344 624.753 920.247 427.639 920.247 427.639Z",
    fill: "#53A4DE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter1_f_2216_76033)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M712 793H1079V1039H712V793Z",
    fill: "#0679CC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2216_76033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 -102H503V210H140V-102Z",
    fill: "#0679CC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter3_f_2216_76033)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-216 875H255V1308H-216V875Z",
    fill: "#E0EFFF"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M958.99 859.29C1242.52 1022.99 1605.08 925.842 1768.78 642.308C1932.48 358.774 1835.33 -3.77988 1551.8 -167.478C1268.26 -331.177 905.707 -234.031 742.009 49.5032C578.31 333.037 675.456 695.591 958.99 859.29ZM1027.81 651.881C1230.07 768.655 1488.7 699.356 1605.47 497.097C1722.25 294.839 1652.95 36.212 1450.69 -80.5621C1248.43 -197.336 989.803 -128.037 873.029 74.2213C756.255 276.48 825.554 535.107 1027.81 651.881Z",
    fill: "#0679CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2216_76033",
    x: 620,
    y: 14,
    width: 1071.25,
    height: 1279.64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2216_76033"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2216_76033",
    x: 412,
    y: 493,
    width: 967,
    height: 846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2216_76033"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2216_76033",
    x: -160,
    y: -402,
    width: 963,
    height: 912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2216_76033"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2216_76033",
    x: -516,
    y: 575,
    width: 1071,
    height: 1033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2216_76033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2216_76033",
    x1: 517,
    y1: 549,
    x2: 754,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0679CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2216_76033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupBackground);
export default __webpack_public_path__ + "static/media/signup_background.b086338b4d934bc035c469a900edd609.svg";
export { ForwardRef as ReactComponent };